import styled from 'styled-components/macro';
import Overlay from "./overlay";

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 320px;
  background: ${({theme}) => theme.sidebar.backgroundColor};
  font-size: 15px;
  color: ${({theme}) => theme.sidebar.color};
  height: 100%;
  box-shadow: 0 0 48px rgb(0 0 0/0.2);
  overflow: scroll;
`;

const MobileSidebarContainer = styled(({className, children, onClose, style}) => {
    return (
        <Overlay onClose={onClose}>
            <Wrapper className={className} style={style}>
                {children}
            </Wrapper>
        </Overlay>
    );
})``;

export default MobileSidebarContainer;
